function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.7059 13.8174H15.6934L21.9309 20.0674L20.0684 21.9299L13.8184 15.6924V14.7049L13.4809 14.3549C12.0559 15.5799 10.2059 16.3174 8.19336 16.3174C3.70586 16.3174 0.0683594 12.6799 0.0683594 8.19238C0.0683594 3.70488 3.70586 0.0673828 8.19336 0.0673828C12.6809 0.0673828 16.3184 3.70488 16.3184 8.19238C16.3184 10.2049 15.5809 12.0549 14.3559 13.4799L14.7059 13.8174ZM2.56836 8.19238C2.56836 11.3049 5.08086 13.8174 8.19336 13.8174C11.3059 13.8174 13.8184 11.3049 13.8184 8.19238C13.8184 5.07988 11.3059 2.56738 8.19336 2.56738C5.08086 2.56738 2.56836 5.07988 2.56836 8.19238Z"
});

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.62f5b705.svg";
export { ForwardRef as ReactComponent };